module.exports = "/static/fonts/OpenSans-BoldItalic.ttf";